import { Component, ViewChild, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { GridDataResult, GridComponent, PageChangeEvent, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { SaveAlumniDetaisService } from '../../../@services/alumni-application.service';
import { State, SortDescriptor, process, orderBy } from '@progress/kendo-data-query';

@Component({
    selector: 'category-details',
    template: `
      <kendo-grid
          [data]="gridView"
          [pageSize]="5"
          [skip]="skip"
          [pageable]="true"
          [scrollable]="'none'"
          [navigable]="true"
          kendoGridFocusable>
      <kendo-grid-column field="CurrentlyWork" title="Currently Work" width="120">
      </kendo-grid-column>
      <kendo-grid-column field="City" title="City">
      </kendo-grid-column>
      <kendo-grid-column field="State" title="State">
      </kendo-grid-column>
      <kendo-grid-column field="WhatIsSpecialty" title="What Is Specialty">
      </kendo-grid-column>
      <kendo-grid-column field="WhatDepartmentdoyouworkin" title="What Department Do You Work In">
      </kendo-grid-column>
      <kendo-grid-column field="HowLongYouWorkInDepartment" title="How Long You Work In Department">
      </kendo-grid-column>
      <kendo-grid-column field="AreYouManagerInDepartment" title="Are You Manager In Department">
      </kendo-grid-column>
      </kendo-grid>
  `
})
export class CategoryDetailComponent implements OnInit {

    /**
     * The category for which details are displayed
     */
    @Input() public category: Object;

    public gridView: GridDataResult;
    public gridData: any[] = [];
    public skip = 0;

    public state: State = {
        skip: 0,
        take: 10
    };
    public sort: SortDescriptor[] = [{
        field: 'CurrentlyWork',
        dir: 'asc'
    }];

    constructor(private service: SaveAlumniDetaisService) { }

    public ngOnInit(): void {
        /*load products for the given category*/
        this.service.getDetailsByAlumniID(this.category["AlumniID"]).subscribe(data => {
            if (data.ServiceStatus == "SUCCESS") {
                this.gridData = data.DepartmentList;
                this.sortChange(this.sort);
                this.gridView = this.loadItems(this.gridData, this.state);
            }
        }, err => {
        }, () => {
        });
    }

    public sortChange(sort: SortDescriptor[]): void {
        this.sort = sort;
        this.gridView = {
            data: orderBy(this.gridData, sort),
            total: this.gridData.length
        };
    }

    public dataStateChange(state: DataStateChangeEvent): void {
        this.state = state;
        this.gridView = process(this.gridData, this.state);
    }

    private loadItems(gridData: Array<any>, state: State): GridDataResult {
        let gridView: GridDataResult = {
            data: gridData.slice(state.skip, state.skip + state.take),
            total: gridData.length
        };
        return gridView;
    }

    public pageChange({ skip, take }: PageChangeEvent): void {
        this.skip = skip;
    }
}